import React from 'react';
import { ColumnHeaderProvider, ColumnHeader, TableFilterItem, calculateFilterCount } from 'src/presentations/components/molecules/table/columnHeader';

interface SettingsColumnHeaderProps {
  column: any;
  customHeader?: React.ReactNode;
  filterItems?: TableFilterItem[]; // Pre-calculated items from createFilterItems
  currentFilters?: string[];
  onSort?: (columnId: string, direction: 'asc' | 'desc') => void;
  onFilter?: (columnId: string, selectedValues: string[]) => void;
}

export const SettingsColumnHeader: React.FC<SettingsColumnHeaderProps> = ({
  column,
  customHeader,
  filterItems = [],
  currentFilters = [],
  onSort,
  onFilter,
}) => {
  // Calculate badge count
  const count = calculateFilterCount(filterItems, currentFilters);

  return (
    <ColumnHeaderProvider
      column={column}
      sort={{
        ascText: 'Sort A to Z',
        descText: 'Sort Z to A',
        onSort,
      }}
      items={{
        items: filterItems,
        isLoading: false, // Metadata is pre-fetched by parent
        count,
      }}
      filter={{
        initialSelectedValues: currentFilters,
        onFilter,
        autoSelect: true,
      }}
    >
      <ColumnHeader customHeader={customHeader} />
    </ColumnHeaderProvider>
  );
};
